import React, {useState} from 'react';
import Style from './Navbar.module.scss';
import Toggler from "./home/Toggler";
import {Link, useLocation} from "react-router-dom";
import {Box} from "@mui/material";
import {info} from "../info/Info";
import {trackNavigation} from "../analytics";

const links = [
    {
        name: 'Maria',
        to: '/',
        active: 'home'
    },
    {
        name: 'meu livro',
        to: '/livro',
        active: 'livro'
    },
    {
        name: 'como te ajudo?',
        to: '/about',
        active: 'about'
    },
    {
        name: 'Podcast',
        to: '/podcast',
        active: 'podcast'
    }
]

export default function Navbar({darkMode, handleClick}) {
    const location = useLocation()
    const [active, setActive] = useState(location.pathname === '/' ? 'home' : location.pathname.slice(1, location.pathname.length));

    return (
        <Box component={'nav'} width={'100%'} px={{ xs: 2, md: 0 }}>
            <Box style={{ marginTop: "0.3rem"}} component={'ul'} display={'flex'} justifyContent={'center'} alignItems={'center'}
                 gap={{xs: '1rem', sm: '1.5rem', md: '8rem'}}
                 textTransform={'lowercase'} fontSize={'1rem'}>
                {links.map((link, index) => (
                    <Box key={index} component={'li'} className={(link.active === active && !link.type) && Style.active}
                         sx={{borderImageSource: info.gradient}}>
                        <Link to={link.to} onClick={() => {
                            setActive(link.active);
                            trackNavigation(link.name);
                        }}>
                            {!link.type && <p style={{paddingBottom: '0.5rem'}}>{link.name}</p>}
                            {link.type && <h1>{link.name}</h1>}
                        </Link>
                    </Box>
                ))}
                <li>
                    <Toggler darkMode={darkMode} handleClick={handleClick}/>
                </li>
            </Box>
        </Box>
    )
}